/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AccommodationCatalogCitiesResponseDto,
  AccommodationCatalogPageResponseDto,
  BadRequestErrorDto,
  CancellationRuleDto,
  ConflictErrorDto,
  GetPropertyById200Response,
  InternalErrorDto,
  NotFoundErrorDto,
  RoomDto,
  SearchPropertiesByFilterResponse,
  TravelinePropertyInfoDto,
  UnprocessableEntityErrorDto,
} from '../models/index';
import {
    AccommodationCatalogCitiesResponseDtoFromJSON,
    AccommodationCatalogCitiesResponseDtoToJSON,
    AccommodationCatalogPageResponseDtoFromJSON,
    AccommodationCatalogPageResponseDtoToJSON,
    BadRequestErrorDtoFromJSON,
    BadRequestErrorDtoToJSON,
    CancellationRuleDtoFromJSON,
    CancellationRuleDtoToJSON,
    ConflictErrorDtoFromJSON,
    ConflictErrorDtoToJSON,
    GetPropertyById200ResponseFromJSON,
    GetPropertyById200ResponseToJSON,
    InternalErrorDtoFromJSON,
    InternalErrorDtoToJSON,
    NotFoundErrorDtoFromJSON,
    NotFoundErrorDtoToJSON,
    RoomDtoFromJSON,
    RoomDtoToJSON,
    SearchPropertiesByFilterResponseFromJSON,
    SearchPropertiesByFilterResponseToJSON,
    TravelinePropertyInfoDtoFromJSON,
    TravelinePropertyInfoDtoToJSON,
    UnprocessableEntityErrorDtoFromJSON,
    UnprocessableEntityErrorDtoToJSON,
} from '../models/index';

export interface GetAccommodationCatalogRequest {
    cityId: string;
    limit?: number;
    cursor?: string;
}

export interface GetAccommodationCatalogCitiesRequest {
    countryCodes?: Array<GetAccommodationCatalogCitiesCountryCodesEnum>;
}

export interface GetCancellationRulesRequest {
    ratePlanId: string;
    propertyId: string;
    adults: number;
    arrivalDate: string;
    departureDate: string;
    roomTypeId?: string;
    orderNumber?: string;
    childAges?: Array<number>;
}

export interface GetPropertyByIdRequest {
    propertyId: string;
    roomTypeId?: string;
}

export interface GetPropertyDetailsRequest {
    propertyId: string;
}

export interface GetRoomsByPropertyIdRequest {
    propertyId: string;
    adults: number;
    arrivalDate: string;
    departureDate: string;
    childAges?: Array<number>;
    roomTypeId?: string;
    page?: number;
    size?: number;
    sort?: GetRoomsByPropertyIdSortEnum;
}

export interface SearchPropertiesByFilterRequest {
    cityId: string;
    adults: number;
    arrivalDate: string;
    departureDate: string;
    childAges?: Array<number>;
    page?: number;
    size?: number;
    sort?: SearchPropertiesByFilterSortEnum;
}

/**
 * 
 */
export class PropertyApi extends runtime.BaseAPI {

    /**
     * Returns confirmed database inventory without dates, guest filters, prices or availability checks.
     * Get accommodation catalog page
     */
    async getAccommodationCatalogRaw(requestParameters: GetAccommodationCatalogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccommodationCatalogPageResponseDto>> {
        if (requestParameters['cityId'] == null) {
            throw new runtime.RequiredError(
                'cityId',
                'Required parameter "cityId" was null or undefined when calling getAccommodationCatalog().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['cityId'] != null) {
            queryParameters['cityId'] = requestParameters['cityId'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['cursor'] != null) {
            queryParameters['cursor'] = requestParameters['cursor'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/catalog/accommodations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccommodationCatalogPageResponseDtoFromJSON(jsonValue));
    }

    /**
     * Returns confirmed database inventory without dates, guest filters, prices or availability checks.
     * Get accommodation catalog page
     */
    async getAccommodationCatalog(requestParameters: GetAccommodationCatalogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccommodationCatalogPageResponseDto> {
        const response = await this.getAccommodationCatalogRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns confirmed database inventory without dates, guest filters, prices or availability checks.
     * Get accommodation catalog cities
     */
    async getAccommodationCatalogCitiesRaw(requestParameters: GetAccommodationCatalogCitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccommodationCatalogCitiesResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['countryCodes'] != null) {
            queryParameters['countryCodes'] = requestParameters['countryCodes'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/catalog/accommodations/cities`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccommodationCatalogCitiesResponseDtoFromJSON(jsonValue));
    }

    /**
     * Returns confirmed database inventory without dates, guest filters, prices or availability checks.
     * Get accommodation catalog cities
     */
    async getAccommodationCatalogCities(requestParameters: GetAccommodationCatalogCitiesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccommodationCatalogCitiesResponseDto> {
        const response = await this.getAccommodationCatalogCitiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns cancellation rules for a specific property based on arrival and departure dates
     * Get cancellation rules by property ID
     */
    async getCancellationRulesRaw(requestParameters: GetCancellationRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CancellationRuleDto>> {
        if (requestParameters['ratePlanId'] == null) {
            throw new runtime.RequiredError(
                'ratePlanId',
                'Required parameter "ratePlanId" was null or undefined when calling getCancellationRules().'
            );
        }

        if (requestParameters['propertyId'] == null) {
            throw new runtime.RequiredError(
                'propertyId',
                'Required parameter "propertyId" was null or undefined when calling getCancellationRules().'
            );
        }

        if (requestParameters['adults'] == null) {
            throw new runtime.RequiredError(
                'adults',
                'Required parameter "adults" was null or undefined when calling getCancellationRules().'
            );
        }

        if (requestParameters['arrivalDate'] == null) {
            throw new runtime.RequiredError(
                'arrivalDate',
                'Required parameter "arrivalDate" was null or undefined when calling getCancellationRules().'
            );
        }

        if (requestParameters['departureDate'] == null) {
            throw new runtime.RequiredError(
                'departureDate',
                'Required parameter "departureDate" was null or undefined when calling getCancellationRules().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['roomTypeId'] != null) {
            queryParameters['roomTypeId'] = requestParameters['roomTypeId'];
        }

        if (requestParameters['orderNumber'] != null) {
            queryParameters['orderNumber'] = requestParameters['orderNumber'];
        }

        if (requestParameters['adults'] != null) {
            queryParameters['adults'] = requestParameters['adults'];
        }

        if (requestParameters['childAges'] != null) {
            queryParameters['childAges'] = requestParameters['childAges']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['arrivalDate'] != null) {
            queryParameters['arrivalDate'] = requestParameters['arrivalDate'];
        }

        if (requestParameters['departureDate'] != null) {
            queryParameters['departureDate'] = requestParameters['departureDate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/properties/{propertyId}/cancellation-rules/{ratePlanId}`.replace(`{${"ratePlanId"}}`, encodeURIComponent(String(requestParameters['ratePlanId']))).replace(`{${"propertyId"}}`, encodeURIComponent(String(requestParameters['propertyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CancellationRuleDtoFromJSON(jsonValue));
    }

    /**
     * Returns cancellation rules for a specific property based on arrival and departure dates
     * Get cancellation rules by property ID
     */
    async getCancellationRules(requestParameters: GetCancellationRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CancellationRuleDto> {
        const response = await this.getCancellationRulesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get detailed information about a specific property
     * Get property by ID
     */
    async getPropertyByIdRaw(requestParameters: GetPropertyByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPropertyById200Response>> {
        if (requestParameters['propertyId'] == null) {
            throw new runtime.RequiredError(
                'propertyId',
                'Required parameter "propertyId" was null or undefined when calling getPropertyById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['roomTypeId'] != null) {
            queryParameters['roomTypeId'] = requestParameters['roomTypeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/properties/{propertyId}`.replace(`{${"propertyId"}}`, encodeURIComponent(String(requestParameters['propertyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPropertyById200ResponseFromJSON(jsonValue));
    }

    /**
     * Get detailed information about a specific property
     * Get property by ID
     */
    async getPropertyById(requestParameters: GetPropertyByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPropertyById200Response> {
        const response = await this.getPropertyByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get details of property by ID
     * Get property details
     */
    async getPropertyDetailsRaw(requestParameters: GetPropertyDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TravelinePropertyInfoDto>> {
        if (requestParameters['propertyId'] == null) {
            throw new runtime.RequiredError(
                'propertyId',
                'Required parameter "propertyId" was null or undefined when calling getPropertyDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/properties/details/{propertyId}`.replace(`{${"propertyId"}}`, encodeURIComponent(String(requestParameters['propertyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TravelinePropertyInfoDtoFromJSON(jsonValue));
    }

    /**
     * Get details of property by ID
     * Get property details
     */
    async getPropertyDetails(requestParameters: GetPropertyDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TravelinePropertyInfoDto> {
        const response = await this.getPropertyDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get rooms by property id
     * Get rooms by property id
     */
    async getRoomsByPropertyIdRaw(requestParameters: GetRoomsByPropertyIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RoomDto>>> {
        if (requestParameters['propertyId'] == null) {
            throw new runtime.RequiredError(
                'propertyId',
                'Required parameter "propertyId" was null or undefined when calling getRoomsByPropertyId().'
            );
        }

        if (requestParameters['adults'] == null) {
            throw new runtime.RequiredError(
                'adults',
                'Required parameter "adults" was null or undefined when calling getRoomsByPropertyId().'
            );
        }

        if (requestParameters['arrivalDate'] == null) {
            throw new runtime.RequiredError(
                'arrivalDate',
                'Required parameter "arrivalDate" was null or undefined when calling getRoomsByPropertyId().'
            );
        }

        if (requestParameters['departureDate'] == null) {
            throw new runtime.RequiredError(
                'departureDate',
                'Required parameter "departureDate" was null or undefined when calling getRoomsByPropertyId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['adults'] != null) {
            queryParameters['adults'] = requestParameters['adults'];
        }

        if (requestParameters['childAges'] != null) {
            queryParameters['childAges'] = requestParameters['childAges']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['arrivalDate'] != null) {
            queryParameters['arrivalDate'] = requestParameters['arrivalDate'];
        }

        if (requestParameters['departureDate'] != null) {
            queryParameters['departureDate'] = requestParameters['departureDate'];
        }

        if (requestParameters['roomTypeId'] != null) {
            queryParameters['roomTypeId'] = requestParameters['roomTypeId'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/properties/{propertyId}/rooms`.replace(`{${"propertyId"}}`, encodeURIComponent(String(requestParameters['propertyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RoomDtoFromJSON));
    }

    /**
     * Get rooms by property id
     * Get rooms by property id
     */
    async getRoomsByPropertyId(requestParameters: GetRoomsByPropertyIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RoomDto>> {
        const response = await this.getRoomsByPropertyIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search properties by filter
     * Search properties by filter
     */
    async searchPropertiesByFilterRaw(requestParameters: SearchPropertiesByFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchPropertiesByFilterResponse>> {
        if (requestParameters['cityId'] == null) {
            throw new runtime.RequiredError(
                'cityId',
                'Required parameter "cityId" was null or undefined when calling searchPropertiesByFilter().'
            );
        }

        if (requestParameters['adults'] == null) {
            throw new runtime.RequiredError(
                'adults',
                'Required parameter "adults" was null or undefined when calling searchPropertiesByFilter().'
            );
        }

        if (requestParameters['arrivalDate'] == null) {
            throw new runtime.RequiredError(
                'arrivalDate',
                'Required parameter "arrivalDate" was null or undefined when calling searchPropertiesByFilter().'
            );
        }

        if (requestParameters['departureDate'] == null) {
            throw new runtime.RequiredError(
                'departureDate',
                'Required parameter "departureDate" was null or undefined when calling searchPropertiesByFilter().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['cityId'] != null) {
            queryParameters['cityId'] = requestParameters['cityId'];
        }

        if (requestParameters['adults'] != null) {
            queryParameters['adults'] = requestParameters['adults'];
        }

        if (requestParameters['childAges'] != null) {
            queryParameters['childAges'] = requestParameters['childAges']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['arrivalDate'] != null) {
            queryParameters['arrivalDate'] = requestParameters['arrivalDate'];
        }

        if (requestParameters['departureDate'] != null) {
            queryParameters['departureDate'] = requestParameters['departureDate'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/properties`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchPropertiesByFilterResponseFromJSON(jsonValue));
    }

    /**
     * Search properties by filter
     * Search properties by filter
     */
    async searchPropertiesByFilter(requestParameters: SearchPropertiesByFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchPropertiesByFilterResponse> {
        const response = await this.searchPropertiesByFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetAccommodationCatalogCitiesCountryCodesEnum = {
    Rus: 'RUS',
    Blr: 'BLR'
} as const;
export type GetAccommodationCatalogCitiesCountryCodesEnum = typeof GetAccommodationCatalogCitiesCountryCodesEnum[keyof typeof GetAccommodationCatalogCitiesCountryCodesEnum];
/**
 * @export
 */
export const GetRoomsByPropertyIdSortEnum = {
    Price: 'price',
    Rating: 'rating'
} as const;
export type GetRoomsByPropertyIdSortEnum = typeof GetRoomsByPropertyIdSortEnum[keyof typeof GetRoomsByPropertyIdSortEnum];
/**
 * @export
 */
export const SearchPropertiesByFilterSortEnum = {
    Price: 'price',
    Rating: 'rating'
} as const;
export type SearchPropertiesByFilterSortEnum = typeof SearchPropertiesByFilterSortEnum[keyof typeof SearchPropertiesByFilterSortEnum];
